import { create } from "zustand"
import type {
  WeeklyOfWeekly,
  WeeklyObjective,
} from "../entities/weekly-objectives/weekly-objectives"

interface WeeklyObjectivesState {
  currentWeekNumber: number
  weeklyObjectives: WeeklyOfWeekly[]
  selectedWeeklyObjective: WeeklyObjective
  setWeeklyObjectives: (obj: WeeklyOfWeekly[]) => void
  setSelectedWeeklyObjective: (id: string) => void
  setCurrentWeekNumber: (weekNumber: number) => void
}

export const useWeeklyObjectivesStore = create<WeeklyObjectivesState>((set) => ({
  currentWeekNumber: -1,
  weeklyObjectives: [],
  selectedWeeklyObjective: {
    id: "",
    name: "",
    subjectId: "",
    subjectIndex: 0,
    estimatedDuration: 0,
    estimatedRemainingDuration: 0,
    weeklyObjectiveIndex: 0,
    totalActivities: 0,
    approvedActivities: 0,
    status: "approved",
    weekDateTime: new Date().toISOString(),
    realDuration: 0,
  },
  setWeeklyObjectives: (weeklyObjectives: WeeklyOfWeekly[]) => {
    set(() => ({ weeklyObjectives }))
  },
  setSelectedWeeklyObjective: (id: string) => {
    set((state) => {
      const selectedWeeklyObjective =
        state.weeklyObjectives
          .flatMap((wo) => wo.objectives)
          .find((objective) => objective.id === id) || state.selectedWeeklyObjective

      return { selectedWeeklyObjective }
    })
  },
  setCurrentWeekNumber: (weekNumber: number) => {
    set(() => ({ currentWeekNumber: weekNumber }))
  },
}))

export default useWeeklyObjectivesStore.getState()
